var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52.229C6.017.312 3.34 3.07 3.34 6.416c0 1.804.955 3.885 2.125 5.852 1.17 1.966 2.579 3.772 3.662 4.857a.687.687 0 0 0 .973 0c1.084-1.085 2.492-2.891 3.663-4.857 1.17-1.967 2.124-4.048 2.124-5.852A6.196 6.196 0 0 0 9.521.23zm.037 1.373c2.79-.066 4.957 2.105 4.957 4.814 0 1.278-.821 3.285-1.932 5.15a26.005 26.005 0 0 1-2.968 4.02 26.005 26.005 0 0 1-2.969-4.02c-1.11-1.865-1.931-3.872-1.931-5.15 0-2.624 2.028-4.747 4.843-4.814zm.057 1.932A2.886 2.886 0 0 0 6.73 6.409c0 1.584 1.297 2.897 2.883 2.897s2.875-1.313 2.875-2.897a2.88 2.88 0 0 0-2.875-2.875zm0 1.373c.843 0 1.516.66 1.516 1.502s-.673 1.524-1.516 1.524a1.51 1.51 0 0 1-1.51-1.524c0-.842.667-1.502 1.51-1.502zM3.19 13.82a.687.687 0 0 0-.565.422L.28 19.879a.687.687 0 0 0 .637.95h17.389a.687.687 0 0 0 .636-.95l-2.346-5.637a.687.687 0 0 0-.63-.422H14.3a.687.687 0 1 0 0 1.373h1.209l1.774 4.264H1.946l1.766-4.264h1.21a.687.687 0 1 0 0-1.373h-1.66a.687.687 0 0 0-.072 0z",
    fill: "#999",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.576238bbed5dd8a1d438b9efaa90ec5e.svg";
export { ForwardRef as ReactComponent };